import { render } from "./Branch.vue?vue&type=template&id=2b9b7112&scoped=true"
import script from "./Branch.vue?vue&type=script&lang=js"
export * from "./Branch.vue?vue&type=script&lang=js"

import "./Branch.vue?vue&type=style&index=0&id=2b9b7112&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b9b7112"

export default script